import React, { createContext, useContext, useMemo } from "react";
import { useSearchParams } from "react-router-dom";

interface EmbedContextValue {
  isEmbed: boolean;
}

const EmbedContext = createContext<EmbedContextValue>({ isEmbed: false });

export const useEmbed = () => useContext(EmbedContext);

export const EmbedProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [searchParams] = useSearchParams();
  const isEmbed = useMemo(() => searchParams.get("embed") === "1", [searchParams]);

  return (
    <EmbedContext.Provider value={{ isEmbed }}>
      {children}
    </EmbedContext.Provider>
  );
};
